'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('servicerequest-ticket-show', {
      url: '/servicerequest/ticket/detail/:id',
      template: '<service-request-ticket-show></service-request-ticket-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/servicerequests/ticket-show/servicerequest-ticket-show.routes.js